import { of } from 'rxjs';

import { enqueueSnackbar } from './notifier/actions';
import { setError, requestFailed } from './status/actions';

export interface AppError {
  status?: number;
  message: string;
}

export const handleError = (error: AppError) => {
  if (error.status === 503) {
    return of(requestFailed(), setError('NETWORK_ERROR'));
  }

  return of(
    requestFailed(),
    enqueueSnackbar({
      message: error.message,
      options: { variant: 'error' },
    })
  );
};
